module.exports = __webpack_public_path__ + "assets/images/magenta_sport_3_league.ac45dfd1baac73d83edfa817934946b5.png";